import React from 'react';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

// Mirrors App.css's --primary-color/--secondary-color/--text-color/--text-muted (Chart.js draws
// to canvas, which can't resolve CSS custom properties, so the values are duplicated here - keep
// both in sync if the theme palette ever changes).
const CHART_COLORS = {
  primary: '#555d71',
  secondary: '#7f8aa8',
  tertiary: '#9aa4bd',
  text: 'rgba(255, 255, 255, 0.85)',
  grid: 'rgba(255, 255, 255, 0.08)',
};

const commonOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'bottom', labels: { color: CHART_COLORS.text } },
  },
  scales: {
    x: { ticks: { color: CHART_COLORS.text }, grid: { color: CHART_COLORS.grid } },
    y: { ticks: { color: CHART_COLORS.text, precision: 0 }, grid: { color: CHART_COLORS.grid }, beginAtZero: true },
  },
};

// "Fun graphs and statistics" section - built entirely from data already present in `stats`/
// `timeline`, no extra backend endpoints needed.
const PeriodGraphs = ({ stats, timeline }) => {
  const categoryData = {
    labels: ['Games', 'Anime', 'Shows', 'Manga/Books'],
    datasets: [
      {
        label: 'Started',
        data: [stats.games_started, stats.anime_started, stats.shows_started, stats.manga_started],
        backgroundColor: CHART_COLORS.secondary,
      },
      {
        label: 'Finished',
        data: [stats.games_finished, stats.anime_finished, stats.shows_finished, stats.manga_finished],
        backgroundColor: CHART_COLORS.primary,
      },
    ],
  };

  const activityData = {
    labels: timeline.map(day =>
      new Date(`${day.date}T00:00:00`).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
    ),
    datasets: [
      {
        label: 'Activity',
        data: timeline.map(day => day.items.length),
        backgroundColor: CHART_COLORS.tertiary,
      },
    ],
  };

  const hasCategoryData = categoryData.datasets.some(ds => ds.data.some(v => v > 0));
  const hasActivityData = timeline.some(day => day.items.length > 0);

  if (!hasCategoryData && !hasActivityData) {
    return null;
  }

  return (
    <section className="period-summary-section period-summary-graphs">
      <h2>Stats At A Glance</h2>
      <div className="period-summary-graphs-grid">
        {hasCategoryData && (
          <div className="period-summary-graph-card">
            <h3>Started vs Finished</h3>
            <div className="period-summary-graph-canvas">
              <Bar data={categoryData} options={commonOptions} />
            </div>
          </div>
        )}
        {hasActivityData && (
          <div className="period-summary-graph-card">
            <h3>Activity By Day</h3>
            <div className="period-summary-graph-canvas">
              <Bar data={activityData} options={commonOptions} />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PeriodGraphs;
